<template>
  <div>
    <div ref="chart" style="width: 850px; height: 300px;"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'LargeDataBarChart',
  props: {
    incomeData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null,
      categoryData: [],
      valueData: []
    };
  },
  watch: {
    incomeData: {
      handler() {
        this.updateChart();
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.initChart();
  },
  methods: {
    extractChartData() {
      this.categoryData = Object.keys(this.incomeData);
      this.valueData = this.categoryData.map(date => this.incomeData[date].all_incomes);
    },

    initChart() {
      this.chart = echarts.init(this.$refs.chart);
      this.extractChartData();
      this.setChartOption();
      window.addEventListener('resize', () => this.chart.resize());

      // Слушаем изменение диапазона
      this.chart.on('dataZoom', this.updateTitleByZoom);
    },

    getSumInRange(startIndex, endIndex) {
      const rangeValues = this.valueData.slice(startIndex, endIndex + 1);
      return rangeValues.reduce((sum, val) => sum + val, 0);
    },

    updateTitleByZoom() {
      const zoomInfo = this.chart.getOption().dataZoom[0];
      const startIndex = Math.floor((zoomInfo.start / 100) * (this.categoryData.length - 1));
      const endIndex = Math.floor((zoomInfo.end / 100) * (this.categoryData.length - 1));

      const sum = this.getSumInRange(startIndex, endIndex);

      this.chart.setOption({
        title: {
          text: `Сумма: ${sum.toLocaleString()}`
        }
      });
    },

    setChartOption() {
      const sum = this.getSumInRange(0, this.categoryData.length - 1);

      this.chart.setOption({
        title: {
          text: `Сумма: ${sum.toLocaleString()}`,
          left: 10
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' }
        },
        toolbox: {
          feature: {
            dataZoom: { yAxisIndex: false },
            saveAsImage: { pixelRatio: 2 }
          }
        },
        grid: { bottom: 90 },
        dataZoom: [
          { type: 'inside' },
          { type: 'slider' }
        ],
        xAxis: {
          type: 'category',
          data: this.categoryData,
          axisLabel: {
            rotate: 45,
            formatter: value => value.replace('2025-', '')
          }
        },
        yAxis: { type: 'value' },
        series: [
          {
            name: 'Общий доход',
            type: 'bar',
            data: this.valueData,
            large: true,
            itemStyle: { color: '#409eff' },
            label: { show: false },
            emphasis: {
              label: {
                show: true,
                position: 'top',
                formatter: '{c}',
                fontSize: 14,
                fontWeight: 'bold'
              }
            }
          }
        ]
      });
    },

    updateChart() {
      if (this.chart) {
        this.extractChartData();
        this.setChartOption();
      }
    }
  }
};
</script>
